import { validateEmail, validateEmailBulk } from './verymail';

import { Cryptography } from './cryptography';
import { invoiceTotals } from './invoiceTotal';
import { currencyParse } from './currencyParse';
import { phoneNumberGetInternationalString } from './phoneNumberGetInternationalString';
import { toJSON } from './toJSON';
import { initials } from './initials';
import { currencyMask } from './currencyMask';
import { isTrue } from './isTrue';
import { MathCurrency, mathCurrency } from './math.currency';
import { MathCryptography, mathCryptography } from './math.cryptography';
import { sleep } from './sleep';
import { phoneNumberFormatString } from './phoneNumberFormatString';
import { emailGetFromString } from './emailGetFromString';
import { searchObject } from './searchObject';
import { currencies } from './currencies';
import { truncate } from './truncate';
import { dateFormat } from './dateFormat';
import { postgres } from './postgres';
import { publicKeySetString } from './publicKeySetString';
import { publicKeyGetString } from './publicKeyGetString';
import { bloodGroups } from './assets/dictionary/bloodGroups';
import { accountsAsset } from './assets/dictionary/accountsAsset';
import { accountsEquity } from './assets/dictionary/accountsEquity';
import { accountsPayable } from './assets/dictionary/accountsPayable';
import { accountsLiability } from './assets/dictionary/accountsLiability';
import { accountsReceivable } from './assets/dictionary/accountsReceivable';
import { currencyDenomination } from './assets/dictionary/currencyDenomination';
import { estimateTerm } from './assets/dictionary/estimateTerm';
import { invoiceTerm } from './assets/dictionary/invoiceTerm';
import { itemCategory } from './assets/dictionary/productCategory';

const __DEV__ = process.env.NODE_ENV === 'development';

const isTest = process.env.NODE_ENV === 'test';
const isProduction = process.env.NODE_ENV === 'production';
const isAppProduction = process.env.APP_ENVIRONMENT === 'production';
const isAppSandbox = process.env.APP_ENVIRONMENT === 'sandbox';
const isAppLocal = process.env.APP_ENVIRONMENT === 'local';

export {
	__DEV__,
	isTest,
	isProduction,
	isAppProduction,
	isAppSandbox,
	isAppLocal,
	Cryptography,
	MathCurrency,
	mathCurrency,
	MathCryptography,
	mathCryptography,
	validateEmail,
	validateEmailBulk,
	emailGetFromString,
	currencyParse,
	currencyMask,
	currencies,
	invoiceTotals,
	phoneNumberGetInternationalString,
	phoneNumberFormatString,
	postgres,
	toJSON,
	initials,
	isTrue,
	sleep,
	truncate,
	dateFormat,
	searchObject,
	publicKeyGetString,
	publicKeySetString,
	bloodGroups,
	accountsAsset,
	accountsEquity,
	accountsLiability,
	accountsPayable,
	accountsReceivable,
	currencyDenomination,
	estimateTerm,
	invoiceTerm,
	itemCategory,
}

/**
 * App dictionary
 */
export * from './assets/dictionary/employmentStatus';
export * from './assets/dictionary/customerTypes';
export * from './assets/dictionary/bankAccountType';
export * from './assets/dictionary/dateFormats';
export * from './assets/dictionary/contactType';
export * from './assets/dictionary/expenseStatus';
export * from './assets/dictionary/salaryFrequency';
export * from './assets/dictionary/leavePolicy';
export * from './assets/dictionary/languages';
export * from './assets/dictionary/taxTypes';
export * from './assets/dictionary/expenseType';
export * from './assets/dictionary/gender';
export * from './assets/dictionary/documentSize';
export * from './assets/dictionary/deliveryNoteStatus';
export * from './assets/dictionary/creditNoteStatus';
export * from './assets/dictionary/invoiceStatus';
export * from './assets/dictionary/estimateStatus';
export * from './assets/dictionary/docTypes';
export * from './assets/dictionary/months';
export * from './assets/dictionary/monthDays';
export * from './assets/dictionary/industries';
export * from './assets/dictionary/cms';
export * from './assets/dictionary/monthNameNumber';
export * from './assets/dictionary/orderStatus';
export * from './assets/dictionary/paymentMethods';
export * from './assets/dictionary/deliveryMethods';
export * from './assets/dictionary/paymentStatus';
export * from './assets/dictionary/paymentTerms';
export * from './assets/dictionary/productTypes';
export * from './assets/dictionary/alphabet';
export * from './assets/dictionary/productUnits';
export * from './assets/dictionary/quoteStatus';
export * from './assets/dictionary/recurringFrequency';
export * from './assets/dictionary/salutations';
export * from './assets/dictionary/weekdays';
export * from './assets/dictionary/timezones';
export * from './assets/dictionary/payoutMethod';
export * from './assets/dictionary/paymentMethod';
export * from './assets/dictionary/transactionStatus';
